// React
import React from 'react';

// Components
import AnimateButton from 'components/@extended/AnimateButton';
// import InputFieldErrorMessage from 'components/common/InputFieldErrorMessage';
import Select from 'components/common/Select';

// Packages
import { Formik } from 'formik';
import * as Yup from 'yup';
import {
    Grid,
    TextField,
    Stack,
    InputLabel,
    // MenuItem,
    Button
} from '@mui/material';

// Utils
import {
    countries,
    nameRegExp,
    phoneRegExp,
    errorMessage
    // canadianProvinces,
    // unitedStates
} from 'utils/constants';
import { capitalizeFirstLetterMulti } from 'utils/Helpers';

const AddOccupantsForm = ({
    occupants,
    setOccupants,
    editingOccupant,
    loading,
    handleAddOrUpdateOccupant,
    setStep
}) => {
    // const currentYear = new Date().getFullYear();
    // const tagCountries = [
    //     { value: 'USA', name: 'United States' },
    //     { value: 'CDN', name: 'Canada' }
    // ];

    const defaultValues = {
        first_name: '',
        last_name: '',
        phone: { code: 1, country: 'US', number: '' }
        // tag: '',
        // country: '',
        // state: '',
        // make: '',
        // model: '',
        // year: '',
        // color: ''
    };

    const initialValues = editingOccupant
        ? {
              first_name: editingOccupant.first_name
                  ? capitalizeFirstLetterMulti(editingOccupant.first_name)
                  : '',
              last_name: editingOccupant.last_name
                  ? capitalizeFirstLetterMulti(editingOccupant.last_name)
                  : '',
              phone: {
                  number: `${editingOccupant.phone?.number}` || '',
                  code: editingOccupant.phone?.code || 1,
                  country: editingOccupant.phone?.country || 'US'
              }
              //   tag: editingOccupant.vehicle ? editingOccupant.vehicle.tag : '',
              //   country: editingOccupant.vehicle ? editingOccupant.vehicle.country : '',
              //   state: editingOccupant.vehicle ? editingOccupant.vehicle.state : '',
              //   make: editingOccupant.vehicle
              //       ? capitalizeFirstLetterMulti(editingOccupant.vehicle.make)
              //       : '',
              //   model: editingOccupant.vehicle
              //       ? capitalizeFirstLetterMulti(editingOccupant.vehicle.model)
              //       : '',
              //   year: editingOccupant.vehicle ? editingOccupant.vehicle.year : '',
              //   color: editingOccupant.vehicle
              //       ? capitalizeFirstLetterMulti(editingOccupant.vehicle.color)
              //       : ''
          }
        : defaultValues;

    // const vehicleFields = ['tag', 'country', 'state', 'make', 'model', 'year', 'color'];

    // const isVehicleInfoRequired = values => {
    //     if (!values) return false; // prevent crash on initial render
    //     return ['tag', 'country', 'state', 'make', 'model', 'year', 'color'].some(
    //         field => {
    //             const val = values[field];
    //             return typeof val === 'string'
    //                 ? val.trim().length > 0
    //                 : val !== undefined && val !== null && val !== '';
    //         }
    //     );
    // };

    const validationSchema = Yup.object().shape(
        {
            first_name: Yup.string()
                .trim()
                .required(errorMessage.firstName.required)
                .matches(nameRegExp.format, errorMessage.firstName.valid),

            last_name: Yup.string()
                .trim()
                .required(errorMessage.lastName.required)
                .matches(nameRegExp.format, errorMessage.lastName.valid),

            phone: Yup.object().shape({
                code: Yup.number().required(),
                country: Yup.string().required(),
                number: Yup.string()
                    .trim()
                    .matches(phoneRegExp.format, errorMessage.phone.valid)
                    .required(errorMessage.phone.required)
            })
            // tag: Yup.string().when(
            //     ['country', 'state', 'make', 'model', 'year', 'color'],
            //     {
            //         is: (country, state, make, model, year, color) =>
            //             [country, state, make, model, year, color].some(v =>
            //                 typeof v === 'string' ? v.trim() : v
            //             ),
            //         then: schema => schema.required(errorMessage.vehicle.tag.required),
            //         otherwise: schema => schema
            //     }
            // ),
            // country: Yup.string().when(
            //     ['tag', 'state', 'make', 'model', 'year', 'color'],
            //     {
            //         is: (tag, state, make, model, year, color) =>
            //             [tag, state, make, model, year, color].some(v =>
            //                 typeof v === 'string' ? v.trim() : v
            //             ),
            //         then: schema =>
            //             schema.required(errorMessage.vehicle.country.required),
            //         otherwise: schema => schema
            //     }
            // ),
            // state: Yup.string().when(
            //     ['tag', 'country', 'make', 'model', 'year', 'color'],
            //     {
            //         is: (tag, country, make, model, year, color) =>
            //             [tag, country, make, model, year, color].some(v =>
            //                 typeof v === 'string' ? v.trim() : v
            //             ),
            //         then: schema =>
            //             schema.required(errorMessage.vehicle.provinceOrState.required),
            //         otherwise: schema => schema
            //     }
            // ),
            // make: Yup.string().when(
            //     ['tag', 'country', 'state', 'model', 'year', 'color'],
            //     {
            //         is: (tag, country, state, model, year, color) =>
            //             [tag, country, state, model, year, color].some(v =>
            //                 typeof v === 'string' ? v.trim() : v
            //             ),
            //         then: schema => schema.required(errorMessage.vehicle.make.required),
            //         otherwise: schema => schema
            //     }
            // ),
            // model: Yup.string().when(
            //     ['tag', 'country', 'state', 'make', 'year', 'color'],
            //     {
            //         is: (tag, country, state, make, year, color) =>
            //             [tag, country, state, make, year, color].some(v =>
            //                 typeof v === 'string' ? v.trim() : v
            //             ),
            //         then: schema => schema.required(errorMessage.vehicle.model.required),
            //         otherwise: schema => schema
            //     }
            // ),
            // year: Yup.number()
            //     .typeError(errorMessage.vehicle.year.invalid)
            //     .min(1900, errorMessage.vehicle.year.minValue)
            //     .max(
            //         new Date().getFullYear() + 1,
            //         errorMessage.vehicle.year.maxValue(new Date().getFullYear() + 1)
            //     )
            //     .when(['tag', 'country', 'state', 'make', 'model', 'color'], {
            //         is: (tag, country, state, make, model, color) =>
            //             [tag, country, state, make, model, color].some(v =>
            //                 typeof v === 'string' ? v.trim() : v
            //             ),
            //         then: schema => schema.required(errorMessage.vehicle.year.required),
            //         otherwise: schema => schema
            //     }),
            // color: Yup.string().when(
            //     ['tag', 'country', 'state', 'make', 'model', 'year'],
            //     {
            //         is: (tag, country, state, make, model, year) =>
            //             [tag, country, state, make, model, year].some(v =>
            //                 typeof v === 'string' ? v.trim() : v
            //             ),
            //         then: schema => schema.required(errorMessage.vehicle.color.required),
            //         otherwise: schema => schema
            //     }
            // )
        },
        [
            // ['tag', 'country'],
            // ['tag', 'state'],
            // ['tag', 'make'],
            // ['tag', 'model'],
            // ['tag', 'year'],
            // ['tag', 'color'],
            // ['country', 'tag'],
            // ['country', 'state'],
            // ['country', 'make'],
            // ['country', 'model'],
            // ['country', 'year'],
            // ['country', 'color'],
            // ['state', 'tag'],
            // ['state', 'country'],
            // ['state', 'make'],
            // ['state', 'model'],
            // ['state', 'year'],
            // ['state', 'color'],
            // ['make', 'tag'],
            // ['make', 'country'],
            // ['make', 'state'],
            // ['make', 'model'],
            // ['make', 'year'],
            // ['make', 'color'],
            // ['model', 'tag'],
            // ['model', 'country'],
            // ['model', 'state'],
            // ['model', 'make'],
            // ['model', 'year'],
            // ['model', 'color'],
            // ['year', 'tag'],
            // ['year', 'country'],
            // ['year', 'state'],
            // ['year', 'make'],
            // ['year', 'model'],
            // ['year', 'color'],
            // ['color', 'tag'],
            // ['color', 'country'],
            // ['color', 'state'],
            // ['color', 'make'],
            // ['color', 'model'],
            // ['color', 'year']
        ]
    );

    const handleSubmitOccupant = (values, { resetForm, setFieldError }) => {
        const trimValue = val => (typeof val === 'string' ? val.trim() : val);

        const normalizedPhone = parseInt(
            values.phone.number.replace(/[^0-9]/g, '').slice(-10)
        );
        // const upperTag = trimValue(values.tag.toUpperCase());

        const isEditing = editingOccupant !== null;
        const currentPhone = editingOccupant?.phone?.number;
        // const currentTag = editingOccupant?.vehicle?.tag?.toUpperCase();

        const phoneExists = occupants.some(o => {
            const number = o.phone?.number;
            return number === normalizedPhone && (!isEditing || number !== currentPhone);
        });

        // const tagExists =
        //     upperTag &&
        //     occupants.some(o => {
        //         const tag = o.vehicle?.tag?.toUpperCase();
        //         return tag === upperTag && (!isEditing || tag !== currentTag);
        //     });

        if (phoneExists) {
            setFieldError(
                'phone.number',
                'This phone number is already used by another occupant.'
            );
            return;
        }

        // if (upperTag && tagExists) {
        //     setFieldError(
        //         'tag',
        //         'This license plate is already used by another occupant.'
        //     );
        //     return;
        // }

        // const vehicleFields = {
        //     tag: upperTag,
        //     country: trimValue(values.country),
        //     state: trimValue(values.state),
        //     make: trimValue(values.make),
        //     model: trimValue(values.model),
        //     year: trimValue(values.year),
        //     color: trimValue(values.color)
        // };

        // const hasVehicleData = Object.values(vehicleFields).some(
        //     val => val !== undefined && val !== null && String(val).trim().length > 0
        // );

        const occupant = {
            first_name: trimValue(values.first_name).toLowerCase(),
            last_name: trimValue(values.last_name).toLowerCase(),
            phone: {
                number: normalizedPhone,
                code: values.phone.code,
                country: values.phone.country
            },
            // vehicle: hasVehicleData ? vehicleFields : null,
            email: false
        };

        handleAddOrUpdateOccupant(occupant);
        resetForm();
    };

    return (
        <Formik
            initialValues={initialValues}
            validateOnChange
            validateOnBlur
            enableReinitialize
            validationSchema={validationSchema}
            onSubmit={handleSubmitOccupant}
        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue
            }) => (
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={3} sx={{ mt: 1 }}>
                        <Grid item xs={12} sm={6}>
                            <Stack spacing={0.5}>
                                <InputLabel>First Name *</InputLabel>
                                <TextField
                                    name="first_name"
                                    fullWidth
                                    value={values.first_name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.first_name && !!errors.first_name}
                                    helperText={touched.first_name && errors.first_name}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Stack spacing={0.5}>
                                <InputLabel>Last Name *</InputLabel>
                                <TextField
                                    name="last_name"
                                    fullWidth
                                    value={values.last_name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.last_name && !!errors.last_name}
                                    helperText={touched.last_name && errors.last_name}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <Stack spacing={0.5}>
                                <InputLabel>Area Code *</InputLabel>
                                <Select
                                    name="phone.country"
                                    value={values.phone.country}
                                    onChange={e => {
                                        const selected = countries.find(
                                            c => c.value === e.target.value
                                        );
                                        if (selected) {
                                            setFieldValue(
                                                'phone.code',
                                                selected.phoneCode
                                            );
                                            setFieldValue(
                                                'phone.country',
                                                selected.value
                                            );
                                        }
                                    }}
                                    options={countries.map(c => ({
                                        key: c.value,
                                        value: c.value,
                                        display: `${c.flagIcon} +${c.phoneCode}`
                                    }))}
                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={12} sm={9}>
                            <Stack spacing={0.5}>
                                <InputLabel>Mobile Phone *</InputLabel>
                                <TextField
                                    name="phone.number"
                                    fullWidth
                                    value={values.phone.number}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={
                                        touched.phone?.number && !!errors.phone?.number
                                    }
                                    helperText={
                                        touched.phone?.number && errors.phone?.number
                                    }
                                />
                            </Stack>
                        </Grid>

                        {/* Vehicle Section (conditionally required) 
                        <Grid item xs={12} sm={4}>
                            <InputLabel>License Plate</InputLabel>
                            <TextField
                                name="tag"
                                fullWidth
                                value={values.tag}
                                inputProps={{
                                    style: { textTransform: 'uppercase' }
                                }}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.tag && !!errors.tag}
                                helperText={touched.tag && errors.tag}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <InputLabel>Country</InputLabel>
                            <Select
                                name="country"
                                value={values.country}
                                onChange={e => {
                                    handleChange(e);
                                    setFieldValue('state', '');
                                }}
                                options={tagCountries.map(loc => ({
                                    key: loc.value,
                                    value: loc.value,
                                    display: loc.name
                                }))}
                                touched={touched.country}
                                error={errors.country}
                            />
                            <InputFieldErrorMessage
                                touched={touched.country}
                                error={errors.country}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <InputLabel>
                                {values.country === 'CDN' ? 'Province' : 'State'}
                            </InputLabel>
                            <Select
                                name="state"
                                value={values.state}
                                onChange={handleChange}
                                options={(values.country === 'CDN'
                                    ? canadianProvinces
                                    : unitedStates
                                ).map(loc => ({
                                    key: loc.value,
                                    value: loc.name
                                }))}
                                touched={touched.state}
                                error={errors.state}
                            />
                            <InputFieldErrorMessage
                                touched={touched.state}
                                error={errors.state}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputLabel>Make</InputLabel>
                            <TextField
                                name="make"
                                fullWidth
                                value={values.make}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.make && !!errors.make}
                                helperText={touched.make && errors.make}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputLabel>Model</InputLabel>
                            <TextField
                                name="model"
                                fullWidth
                                value={values.model}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.model && !!errors.model}
                                helperText={touched.model && errors.model}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputLabel>Year</InputLabel>
                            <TextField
                                name="year"
                                fullWidth
                                value={values.year}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.year && !!errors.year}
                                helperText={touched.year && errors.year}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputLabel>Color</InputLabel>
                            <TextField
                                name="color"
                                fullWidth
                                value={values.color}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.color && !!errors.color}
                                helperText={touched.color && errors.color}
                            />
                        </Grid> */}

                        {/* Footer Buttons */}
                        <Grid item xs={12} sm={4}>
                            <AnimateButton>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    className="oeGoBack"
                                    onClick={() => {
                                        setStep('address');
                                    }}
                                    disabled={editingOccupant !== null}
                                    size="large"
                                >
                                    Go Back
                                </Button>
                            </AnimateButton>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <AnimateButton>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    type="submit"
                                    className="oeOccupant"
                                    disabled={loading}
                                    size="large"
                                >
                                    {editingOccupant ? 'Update Occupant' : 'Add Occupant'}
                                </Button>
                            </AnimateButton>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <AnimateButton>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    className="oeFinished"
                                    onClick={() => {
                                        setStep('review');
                                    }}
                                    disabled={
                                        editingOccupant !== null || occupants.length === 0
                                    }
                                    size="large"
                                >
                                    Finished
                                </Button>
                            </AnimateButton>
                        </Grid>
                    </Grid>
                </form>
            )}
        </Formik>
    );
};

export default AddOccupantsForm;
